import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import YellowLoveImg from "../assets/yellowLove.svg";
import Footer from "./Footer";
import CustomButton from "./custom/CustomButton";
import axiosStrapiInstance, { baseUrl } from "../axiosStrapi";
import { toast } from "react-toastify";
import Loader from "./custom/Loader";
import CustomGalleryModal from "./custom/CustomGalleryModal";

const ParticularGroup = () => {
  const location = useLocation();
  const [groupDetail, setGroupDetail] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 20);

    const groupName = location?.search?.slice(9)?.replaceAll("&", "%26");
    // ?.replaceAll("%20", " ")
    // ?.replaceAll("%27", "'");
    fetchGroupDetails(groupName);
  }, []);

  async function fetchGroupDetails(groupName) {
    try {
      setLoading(true);
      setTimeout(async (item) => {
        const response = await axiosStrapiInstance.get(
          `/api/groups?filters[title][$eq]=${groupName}&populate=*`
        );
        const result = response?.data?.data?.map((item) => ({
          ...item,
          image: `${baseUrl}${item?.image?.url}`,
          galleryImages: item?.galleryImages?.map(
            (item) => `${item?.url}`
          ),
        }));
        setGroupDetail(result[0]);
        setLoading(false);
      }, 200);
    } catch (error) {
      setLoading(false);
      console.log("error while submiting form", error);
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
    }
  }
  return (
    <div className="min-h-[500px]  justify-center flex items-center">
      {loading ? (
        <Loader />
      ) : (
        <div className="px-[4%] py-[5%] sm:pt[5%] sm:pb-0 w-full">
          <div className="flex flex-col relative gap-2">
            <img
              src={YellowLoveImg}
              alt="yellow heart"
              className="h-[60px] w-[60px] absolute top-[-2%] sm:top-[-10%] lg:top-[10%] right-[0%] lg:right-[10%]"
            />
            <p>
              <span className="text-[#383838] text-[34px] sm:text-[63px] font-bold leading-[42px] sm:leading-[78.12px] font-Wonderbar">
                {groupDetail?.title}{" "}
              </span>
              {groupDetail?.titleSubHeading && (
                <span className="text-[#d31c4f] sm:inline block mb-1 text-[24px] sm:text-[36px] font-normal capitalize leading-[32px] sm:leading-[52.08px]">
                  //{groupDetail?.titleSubHeading}
                </span>
              )}
            </p>
            <p className="text-[#d31c4f] sm:text-justify mt-5 text-xl sm:text-2xl font-normal leading-5 sm:leading-[33.60px]">
              {groupDetail?.subHeading}
            </p>
          </div>
          <div className="flex text-justify font-Lato text-[#101010] text-sm sm:text-2xl font-normal leading-5 sm:leading-[38.40px] mt-[40px] flex-col gap-3 sm:gap-5">
            <p>{groupDetail?.content}</p>
            <p>{groupDetail?.content2}</p>
            <p>{groupDetail?.content3}</p>
          </div>

          {groupDetail?.title !== "Out Of The Box" && (
            <CustomButton
              marginY="10px"
              marginX={"0px"}
              text={`View ${groupDetail?.title ?? ""} Website`}
              handleClick={() =>
                window.open(
                  groupDetail?.redirectionLink,
                  "_.blank",
                  "noreferrer",
                  "noopener"
                )
              }
            />
          )}

          <CustomGalleryModal
            images={groupDetail?.galleryImages}
            paddingX={"0%"}
            paddingY={"2%"}
          />
          <div>
            <Footer marginX={"0%"} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ParticularGroup;
